import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Spinner } from 'react-bootstrap';

import { getAllVacanciesAction } from '../../Redux/Actions/VacanciesActions';

import PageHeader from '../../Components/PageHeader/PageHeader';

const Vacancies = () => {

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const vacanciesList = useSelector((e) => e?.VacanciesReducer?.vacanciesList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        dispatch(getAllVacanciesAction())
    }

    return (
        <>
            <PageHeader
                title="Vacancies"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    // { label: 'About', href: '/about' },
                    { label: 'Vacancies' }
                ]}
            />
            <div className="container py-5">
                <h2 className="mb-4">Vacancies</h2>

                {
                    isLoading ?
                        <div className='text-center'>
                            <Spinner animation="border" />
                        </div>
                        :
                        <div className="table-responsive">
                            <table className="table table-striped table-hover" >
                                <thead className="table-secondary">
                                    <tr>
                                        <th>S. No.</th>
                                        <th>Title</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {vacanciesList?.map((item, index) => (
                                        <tr key={item?.id}>
                                            <td>{index + 1}</td>
                                            <td>{item?.title}</td>
                                            <td>
                                                <Button
                                                    onClick={() => {
                                                        window.open(`https://api.coeupdspadelhi.in/uploads/${item?.pdf}`, '_blank');
                                                    }}
                                                    size='sm'
                                                >
                                                    View
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                }

            </div>
        </>
    );
};

export default Vacancies;
